import React, { createContext, useState, useContext, useCallback } from 'react';

const PageLoaderContext = createContext(null);

export const usePageLoader = () => {
  const context = useContext(PageLoaderContext);
  if (!context) {
    throw new Error('usePageLoader must be used within PageLoaderProvider');
  }
  return context;
};

export const PageLoaderProvider = ({ children }) => {
  const [pageLoading, setPageLoadingState] = useState(false);

  const setPageLoading = useCallback((value) => {
    setPageLoadingState(Boolean(value));
  }, []);

  const value = { pageLoading, setPageLoading };

  return (
    <PageLoaderContext.Provider value={value}>
      {children}
    </PageLoaderContext.Provider>
  );
};
